import { render, staticRenderFns } from "./SurveyFO.vue?vue&type=template&id=67070970"
import script from "./SurveyFO.vue?vue&type=script&lang=js"
export * from "./SurveyFO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports